import { __read, __spread } from "tslib";
import { useEffect, useState } from "react";

export var useSwitch = function (initialState?: any) {
    if (initialState === void 0) {
        initialState = false;
    }
    var _a = __read(useState(initialState), 2),
        state = _a[0],
        setState = _a[1];
    var toggleOn = function () {
        setState(true);
    };
    var toggleOff = function () {
        setState(false);
    };
    var toggle = function (value: boolean) {
        setState(typeof value === "boolean" ? value : !state);
    };
    return [state, toggle, toggleOn, toggleOff];
};

export var useAsyncEffect = function (effect: any, resolve: any, reject?: any, deps?: any) {
    if (deps === void 0) {
        deps = [];
    }
    var _a = __read(useSwitch(), 2),
        trigger = _a[0],
        triggerRefresh = _a[1];
    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function () {
        var cancelled = false;
        var controller = new AbortController();
        var abort = controller.abort,
            signal = controller.signal;
        var props = { abort: abort, signal: signal };
        effect(props)
            .then(function (results: any) {
                if (!cancelled && resolve) resolve(results);
            })
            .catch(function (error: any) {
                if (error.name !== "AbortError" && reject) reject(error);
            });
        return function () {
            cancelled = true;
            controller.abort();
        };
    }, __spread([trigger], deps));
    /* eslint-enable react-hooks/exhaustive-deps */
    return triggerRefresh;
};
